import { SET_CONTROLLED_FILTERS_OPEN, SET_LOADER } from './actionTypes'

export const setControlledFiltersOpen = (filters) => {
    return {
        type : SET_CONTROLLED_FILTERS_OPEN,
        data : filters
    }
}

export const setLoaderStatus = (loaderStat) => {
    return {
        type : SET_LOADER,
        status : loaderStat
    }
}
